import { assistedCallMode, messageKeepAlive, triggerNotifications } from '../Helpers/helperMessages.js';
import { STRATEGIES_API_RESPONSE } from '../Strategies/Strategies_Api_Response';
import { SM_QUEUE_SERVER, ASSISTED_TRANSFER, BLIND_TRANSFER, SHOW_TRANSFERS_BUTTONS, LIST_STATES, STATE_TO_PLAY_END_AUDIO} from '../constants/constants.js';
import { callReceivedToModel } from '../mappers/models.mapper.js';
import { chatStatusProblem, svrGetChatLog } from '../components/chatToAdmin.js';
import { generateAudio } from '../components/audiosSDK.js';
import { Logger } from '../logging/Logger.js';
import { validateContactData } from '../utils/utils.js';
import { MESSAGE_FROM, MESSAGE_TYPE } from '../constants/Notifications.js';
import { Singleton } from '../Singletons/Singleton.js';
import { STRATEGIES_ALERTS } from './Strategies_Alerts_And_Errors.js';

const language = new Singleton();
export const STRATEGIES_ACTIONS = {
  "RingingListening": (message, that) => {
    STRATEGIES_ACTIONS["dataCall"](message, that); 
  },
  "CallTypeRecive": (message, that) => { 
    that.state.callType = message.callType;
    },
  "chatAdmin": function (message, that) {
    if(message?.From === "~CallCenterSVR") {
      generateAudio(that, 'chat2');
      chatStatusProblem(that, message);
      return;
    }
      generateAudio(that, 'chat2');
      svrGetChatLog(that, message);
  },
  "dataCall": function (message, that) {
    that.sharedCallOutData.cleanCallData();
    if (message.CallId) {
      that.callId = message.CallId;
      that.sharedCallOutData.callID = message.CallId;
    }
    if (message.CallOutId!=that.callOutId && that.callOutId) {
      message.CallOutId=that.callOutId;
    }
    let speaker = that.sharedData.getVolumeSpeaker();
    let microphone = that.sharedData.getVolumeMic();
    if (speaker === 0) {
      speaker = 70;
      that.sharedData.setVolumeSpeaker(speaker);
    }
    if (microphone === 0) {
      microphone = 70;
      that.sharedData.setVolumeMic(microphone);
      that.sharedData.setPrevVolumenMicro(microphone);
    }
    that.sharedData.setIsMute(false);
    let objectData = {
      UserId: that.sharedData.getParameters().UserID,
      Id: message.Id,
      CallType: message.CallType,
      CallOutId: message.CallOutId,
      Phone: message.Phone
    };
    let objectResponseCallIcon = that.apiCont.getObjectResponse();
    that.apiCont.callIcon(objectData, objectResponseCallIcon);
    objectResponseCallIcon.onError = (err) => {
      Logger.Warn("[AgentSDK] [ResponseFromServer] [Error] apiCont.callIcon objectData:", objectData, "error:", err);
      message.Description="";
      that.sharedData.setCallIcon(null);
      if (message.action!="RingingListening") {
        const callReceived = callReceivedToModel(message);
        that.sharedData.lastCall = callReceived;
        that.svrEvents.onCallReceived(callReceived);
        that.sharedCallOutData.setCallOutDataFromCall(callReceived);
      }
    };
    objectResponseCallIcon.onSuccess = function (objResponse) {
      message.Description=objResponse.Description;
      message.GraphicID = objResponse.GraphicID;
      message.Frame = objResponse.Frame;
      that.sharedData.setCallIcon(objResponse);
      that.sharedData.setIsStopRecording(false);
      that.sharedData.setConnectedTransfer(false);
      if (message.action!="RingingListening") {
        if (that.sharedData.isAssistedMode) {
          message.CalKey = message.CalKey || that.sharedCallOutData.assistedCallKey;
          if (message.DataContact.every(item => item === "" || item === null)) {
            message.DataContact = that.sharedCallOutData.assistedData;
          }
        }
        message.DataContact= validateContactData(message.DataContact);
        const callReceived = callReceivedToModel(message);
        that.sharedData.lastCall = callReceived;
        that.sharedData.setPermissionHoldCamp(callReceived.holdCall);
        that.sharedData.setMainCall(true);
        that.sharedCallOutData.setCallOutDataFromCall(callReceived);
        that.svrEvents.onCallReceived(callReceived);
      }
      if(objResponse){
        that.sharedData.setStartStopRecording(objResponse.IsStartStopRecording);
      }
      that.sharedData.setTemporalCallData(message, 'callReceived');
      that.sharedData.isCallTypeInbound = message.CallType === 1;
    }
    
    that.agentController.volumeSpeaker(speaker);
    that.agentController.volumeMicrophone(microphone);
    that.connectCall(message, that.sharedData.getParameters().UserID);
  },
  "extraDataCall": function (message, that) {
    if (message.CallId) {
      that.callId = message.CallId;
    }

    if (message.SrcUserId) {
      that.connectCall(message, message.SrcUserId);
      let objectData = {
        UserId: that.sharedData.getParameters().UserID,
        Id: message.Id,
        CallType: message.CallType,
        CallOutId: message.CallOutId,
        Phone: message.Phone
      };
      let objectResponseCallIcon = that.apiCont.getObjectResponse();
      that.apiCont.callIcon(objectData, objectResponseCallIcon);
      objectResponseCallIcon.onError = (err) => {
        Logger.Warn(" [AgentSDK] [ResponseFromServer] [Error] apiCont.callIcon objectData:", objectData, "error:", err);
        message.Description="";
        that.sharedData.setCallIcon(null);
        if (message.action!="RingingListening") {
          message.DataContact = (message?.AgentXfer ?? false) ? validateContactData(message.ContactData) : validateContactData();
          message.CalKey = (message?.AgentXfer ?? false) ? message.CalKey : '';
          that.sharedData.setToolsTransfer(message);
          const callReceived = callReceivedToModel(message);
          if(callReceived.callId<0){
            callReceived.callId=callReceived.callId*-1;
          }
          that.sharedCallOutData.setCallOutDataFromCall(callReceived);
          that.svrEvents.onCallReceived(callReceived);
        }
      };
      objectResponseCallIcon.onSuccess = function (objResponse) {
        message.Description= objResponse.Description;
        message.GraphicID = objResponse.GraphicID;
        message.Frame = objResponse.Frame;
        that.sharedData.setCallIcon(objResponse);
        that.sharedData.setStartStopRecording(message?.AgentXfer ?? false);
        that.sharedData.setIsStopRecording(message?.AgentXfer ?? false);
        if (message.action!="RingingListening") {
          message.DataContact = (message?.AgentXfer ?? false) ? validateContactData(message.ContactData) : validateContactData();
          message.CalKey = (message?.AgentXfer ?? false) ? message.CalKey : '';
          that.sharedData.setToolsTransfer(message);
          const callReceived = callReceivedToModel(message);
          if(callReceived.callId<0){
            callReceived.callId=callReceived.callId*-1;
          }
          that.sharedData.setPermissionHoldCamp(callReceived.holdCall);
          that.sharedCallOutData.setCallOutDataFromCall(callReceived);
          that.svrEvents.onCallReceived(callReceived);
          that.sharedData.setTemporalCallData(message, 'callReceived');
          that.sharedData.isCallTypeInbound = callReceived.callType === 1;
        }
      }
    }
    else {
      switch (message.Type) {
        case ASSISTED_TRANSFER.SECOND_CALL_CONNECTED:
          that.sharedData.setConnectedTransfer(true);
          const messageEvent = {
            success: true,
            message: "Second call connecting",
          }
          that.svrEvents.onSecondCallConnected(messageEvent);
          break;
        case ASSISTED_TRANSFER.ON_STATUS:
          if(that.sharedData.getConnectedTransfer()){
            const messageEvent = {
              success: true,
              message: "Second call initiated successfully.",
              secondCall:true,
            }
            that.svrEvents.onSecondCall(messageEvent);
            that.sharedData.setMainCall(false);
          }
          break;
        case ASSISTED_TRANSFER.SECOND_CALL_HANG_UP:
          const messageEventHangUpSec = {
            success: true,
            message: "Second call hang up",
          }
          that.svrEvents.onSecondCallHangUp(messageEventHangUpSec);
          that.sharedData.setMainCall(true);
          that.sharedData.setConnectedTransfer(false);
          const titleTransferError = language.getText("GUIAlertTransfertransferError");
          if(message.AlertCode !== '0') {
            if(message.AlertCode === '1517'){
              let msg = language.getText("GUIAlertTransferswitchedError");
              console.log(titleTransferError + ': ' + msg);
              triggerNotifications(that, message.AlertCode, MESSAGE_TYPE.ERROR, MESSAGE_FROM.CW, titleTransferError + ': ' + msg);
            }
            else{
              let msg = language.getText(
                message.AlertCode === '1501' 
                ? 'CallControlGUICallTransferno-answer-error' 
                : 'alert-' + message.AlertCode
              );
              console.log(titleMsg + ': ' + msg);
              triggerNotifications(that, message.AlertCode, MESSAGE_TYPE.ERROR, MESSAGE_FROM.CW, titleMsg + ': ' + msg);
            }
          }
          break;
        case ASSISTED_TRANSFER.CONFERENCE_CALL_CONNECTED:
          that.sharedData.setConferenceCallID(message.CallId);
          const messageEventConference = {
            success: true,
            message: "Conference call connected successfully",
          }
          that.svrEvents.onConferenceCallConnected(messageEventConference);
          break;
        case ASSISTED_TRANSFER.CONFERENCE_CALL_HANG_UP:
          that.sharedData.setConferenceHangUpOther(message.CallId);
          that.sharedData.setConnectedTransfer(false);
          const messageEventConferenceHang = {
            success: true,
            message: "Conference call hang up",
          }
          that.svrEvents.onConferenceCallHangUp(messageEventConferenceHang);
          break;
        case ASSISTED_TRANSFER.NEW_SECOND_CALL_SET:
          const messageNewSecondCall = {
            success: true,
            message: "New second call set",
          }
          that.svrEvents.onConferenceNewSecondCallSet(messageNewSecondCall);
          break;
        case ASSISTED_TRANSFER.IDDLE_END:
          const messageIddleEnd = {
            success: true,
            message: "Assisted transfer iddle end",
          }
          that.svrEvents.onIddleEnd(messageIddleEnd);
          break;
        case BLIND_TRANSFER.BLIND_TRANSFER_HANG_UP:
          const titleMsg = language.getText('GUIAlertTransfertransferError')
          let msg = language.getText(
            message.AlertCode === '1501' 
            ? 'CallControlGUICallTransferno-answer-error' 
            : 'alert-' + message.AlertCode
          );
          if (!msg) { msg = language.getText("CallControlGUICallTransferBlindXferError"); }
          console.log(titleMsg + ': ' + msg);
          triggerNotifications(that, message.AlertCode, MESSAGE_TYPE.ERROR, MESSAGE_FROM.CW, titleMsg + ': ' + msg);
          break;
        default:
          break;
        }

    }
  },
  "dialogTime": (message,that) => {
    that.svrEvents.onCallEnds(message);
    that.sharedData.setTemporalCallData(message, 'callEnds');
    if(that.sharedData.isCallTypeInbound){
      that.sharedData.setLastCallDataInbound();
    }else{
      that.sharedData.setLastCallDataOutbound();
    }
    that.sharedData.isCallTypeInbound = false;
    if(that.sharedData.getIsHangedUpByAgent()=== STATE_TO_PLAY_END_AUDIO.HANG_UP_CLIENT){
      const audioToPlay = that.sharedData.getAudioNotificationCallEnd();
        if(audioToPlay){
            const audio = new Audio(audioToPlay);
            audio.play();
        }
    }
  },
  "StartKeepAlive": function (message, that) {
    if (!that.timerKeepAlive) {
      that.timerKeepAlive = setInterval(keepAlive, 10000);
      const _that = that;
      function keepAlive() {
        let msgKeepAlive = messageKeepAlive(_that.sharedData.getUserData().Login, _that.agentController.getTimeStamp());
        _that.sendToRabbit(SM_QUEUE_SERVER, msgKeepAlive);
      }
    }
  },
  "queueCall": function (message, that) {
    let callOnQueueInbound = { acdID: message.IdACDReceived, nQueue: message.CountACDReceived, secondsOnQueue: message.SecondsACDReceived };
    let callsOnQueueGlobal= that.sharedData.getCallsOnQueue();
    if (Object(callsOnQueueGlobal).length > 0) {
        let acdExist=callsOnQueueGlobal.find(acd=> acd.acdID==callOnQueueInbound.acdID);
        if (acdExist) {
            let index = callsOnQueueGlobal.indexOf(acdExist);
            callsOnQueueGlobal.splice(index, 1, callOnQueueInbound);
        } else {
            callsOnQueueGlobal.push(callOnQueueInbound);
        }
    } else {
        callsOnQueueGlobal.push(callOnQueueInbound);
    }
    callsOnQueueGlobal.sort();
    that.sharedData.setCallsOnQueue(callsOnQueueGlobal);
    that.svrEvents.onQueueCall(callsOnQueueGlobal);
  },
  "ApiResponse": function (message, that) {
    STRATEGIES_API_RESPONSE[message.Subaction](message, that);
  },
  "notReadyScheduled": (message, that) => {
    console.warn("notReadyScheduled");
  },
  "NewPreviewCall": (message, that) => {
    that.sharedData.isAssistedMode = message.ExitAssistedDialMode;
    that.sharedCallOutData.assistedCallKey = message.CallKey;
    that.sharedCallOutData.assistedData1 = message.Data[0];
    that.sharedCallOutData.assistedData = message.Data;
    const data = assistedCallMode(message.CamId, message.CallKey, message.PhoneNumber, message.Data[0]);
    that.sendToRabbit(SM_QUEUE_SERVER, data);
  },
  "TransferPreviewCall": function(message,that){
    Logger.Warn('[AgentSDK]  [STRATEGIES_ACTIONS][TransferPreviewCall] Method not working in SDK');
  },
  "showPreviewDataTransfer": (message,that) =>{
    Logger.Warn('[AgentSDK]  [STRATEGIES_ACTIONS][showPreviewDataTransfer] Method not working in SDK');
  },
  "UPDATE_DATA_CALL": (message,that) =>{
    const { DataContact, IsSave } = message;
    const responseUpdateData  = {
        dataContact: DataContact || ["","","","",""],
        isSave: IsSave || false,
      };
    that.svrEvents.onUpdateData(responseUpdateData);
  },
  "ChangeDialingModeScheduled":(message,that) => {
    Logger.Warn('[AgentSDK]  [STRATEGIES_ACTIONS][ChangeDialingModeScheduled] Method not working in SDK');
  },

  "NotifyCleanDisplay": (message, that) => {
    Logger.Warn("[AgentSDK] NotifyCleanDisplay state previewPro is not implemented");
  },
  "AGENT_BUSY": function (message, that) {
    that.svrEvents.onTransferUnavailableAgent();
  }
}

